import type { GetFeaturesResponse } from 'services/partnersSelfSignup';

import type { FlagsContext } from '../FlagsProvider';

type FeatureFlag = {
  name: `partners.self_signup.${string}`;
  fallbackValue?: boolean;
};

export const features = [
  {
    name: 'partners.self_signup.terms_and_conditions',
    fallbackValue: false,
  },
  {
    name: 'partners.self_signup.in_flow_terms_and_conditions',
    fallbackValue: false,
  },
] as FeatureFlag[];

function transformFeatureFlagInFlagsContext(
  feats: FeatureFlag[],
): FlagsContext['flags'] {
  return Object.fromEntries(
    feats.map(({ name, fallbackValue }) => [
      name.replace('partners.self_signup.', ''),
      { isEnabled: Boolean(fallbackValue), isExperiment: false },
    ]),
  );
}

export const defaultValues = transformFeatureFlagInFlagsContext(features);

export function transformFeatureResponseInFlagsContext(
  data: GetFeaturesResponse,
): FlagsContext['flags'] {
  return Object.fromEntries(
    Object.entries(data).map(([key, value]) => [
      key.replace('partners.self_signup.', ''),
      { isEnabled: value, isExperiment: false },
    ]),
  );
}
